import { FaWhatsapp } from "react-icons/fa";
import { BRAND } from "@/lib/config";

export default function Footer() {
  return (
    <footer
      className="bg-ink text-cream py-16 sm:py-24"
      data-testid="site-footer"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-7">
            <div className="text-xs uppercase tracking-[0.24em] text-cream/50 mb-6">
              A small letter from
            </div>
            <h3 className="font-serif text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-6">
              Team <span className="italic text-terracotta">Curious Roots</span>
            </h3>
            <p className="max-w-xl text-cream/70 text-base sm:text-lg leading-relaxed">
              {`We're a small studio of parents, teachers, and writers building gentle, offline experiences for young Indian families. Wonder Time is our first cohort. Thank you for being here.`}
            </p>
          </div>
          <div className="lg:col-span-4 lg:col-start-9 flex flex-col justify-end gap-4">
            <a
              href={BRAND.whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-3 rounded-full bg-whatsapp text-ink px-6 py-4 font-semibold hover:bg-whatsapp-hover transition-colors w-fit"
              data-testid="footer-whatsapp-btn"
            >
              <FaWhatsapp className="text-xl" />
              Message us on WhatsApp
            </a>
            <div className="text-cream/50 text-sm">
              hello@curiousroots.in · Made with warmth in India
            </div>
          </div>
        </div>
        <nav
          className="mt-16 pt-10 border-t border-cream/15 flex flex-wrap items-center gap-x-5 gap-y-3 sm:gap-x-6"
          data-testid="footer-links"
          aria-label="Footer navigation"
        >
          {[
            {
              label: "Home",
              testid: "footer-link-home",
              href: "https://thecuriousroots.com/",
            },
            {
              label: "About Us",
              testid: "footer-link-about",
              href: "https://thecuriousroots.com/about-curious-roots/",
            },
            {
              label: "Contact Us",
              testid: "footer-link-contact",
              href: "https://thecuriousroots.com/contact-us/",
            },
            {
              label: "Privacy Policy",
              testid: "footer-link-privacy",
              href: "https://thecuriousroots.com/privacy-policy/",
            },
            {
              label: "Terms & Conditions",
              testid: "footer-link-terms",
              href: "https://thecuriousroots.com/terms-and-conditions/",
            },
            {
              label: "Refund & Cancellation Policy",
              testid: "footer-link-refund",
              href: "https://thecuriousroots.com/refund-and-cancellation-policy/",
            },
            {
              label: "Shipping & Delivery Policy",
              testid: "footer-link-shipping",
              href: "https://thecuriousroots.com/shipping-and-delivery-policy/",
            },
          ].map((item, i, arr) => (
            <span key={item.testid} className="flex items-center gap-x-5 sm:gap-x-6">
              <a
                href={item.href || "#"}
                target={item.href ? "_blank" : undefined}
                rel={item.href ? "noopener noreferrer" : undefined}
                className="text-sm text-cream/60 hover:text-cream transition-colors"
                data-testid={item.testid}
              >
                {item.label}
              </a>
              {i < arr.length - 1 && (
                <span className="text-cream/25 select-none" aria-hidden="true">
                  |
                </span>
              )}
            </span>
          ))}
        </nav>

        <div className="mt-10 pt-8 border-t border-cream/15 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 text-xs uppercase tracking-[0.2em] text-cream/40">
          <div>© {new Date().getFullYear()} Curious Roots</div>
          <div>Wonder Time · A 21-day cohort</div>
        </div>
      </div>
    </footer>
  );
}
